import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, TextField, Button, Grid } from '@mui/material';
import { createDepartment } from '../services/api';

const AddDepartment = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleReset = () => {
    setName('');
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!name.trim()) {
      setError('Department Name is required');
      return;
    }
    try {
      await createDepartment({ name });
      setSuccess('Department created successfully');
      setName('');
    } catch (err) {
      setError(err.message || 'Failed to create department');
    }
  };

  return (
    <Box sx={{ maxWidth: 700, mx: 'auto', p: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Add New Department</Typography>
        <Button variant="contained" color="success" onClick={() => navigate('/departments/list')}>Department List</Button>
      </Box>
      <Paper sx={{ p: 3 }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                label="Department Name"
                value={name}
                onChange={e => setName(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4} sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
              <Button type="submit" variant="contained" color="primary">Save</Button>
              <Button type="button" variant="contained" color="error" onClick={handleReset}>Reset</Button>
            </Grid>
            {error && (
              <Grid item xs={12}>
                <Typography color="error">{error}</Typography>
              </Grid>
            )}
            {success && (
              <Grid item xs={12}>
                <Typography color="success.main">{success}</Typography>
              </Grid>
            )}
          </Grid>
        </form>
      </Paper>
    </Box>
  );
};

export default AddDepartment; 